import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames/bind';

import { ComponentProps } from 'lib/component-props';
import withStyles from 'lib/enhancers/withStyles';

import styles from './Container4Column.module.scss';

const cx = classNames.bind(styles);

type Container4ColumnProps = ComponentProps;

const Container4Column = (props: Container4ColumnProps): React.JSX.Element => {
  const { className, rendering } = props;

  return (
    <div className={cx('container-4Column', className)}>
      <div className={cx('container-4Column__col')}>
        <Placeholder key={0} name="hp-container-4column-left-outer" rendering={rendering} disableSuspense={true} />
      </div>
      <div className={cx('container-4Column__col')}>
        <Placeholder key={0} name="hp-container-4column-left-inner" rendering={rendering} disableSuspense={true} />
      </div>
      <div className={cx('container-4Column__col')}>
        <Placeholder key={0} name="hp-container-4column-right-inner" rendering={rendering} disableSuspense={true} />
      </div>
      <div className={cx('container-4Column__col')}>
        <Placeholder key={0} name="hp-container-4column-right-outer" rendering={rendering} disableSuspense={true} />
      </div>
    </div>
  );
};

export default withStyles()<Container4ColumnProps>(Container4Column);
